export default __webpack_public_path__ + "static/media/g_circled.77857217.svg";